import React from 'react';
import styled from 'styled-components';

import { Button, Dialog, ModalPortal } from '@hoffmann/pattern-library-2';

import { useLegalInformationService } from '../../hooks/useLegalInformationService/useLegalInformationService';
import { useLocalisation } from '../../services/localisationContext';

interface Props {
  onClose: () => void;
  t: (key: string) => string;
}

export const TermsOfUseModal: React.FC<Props> = ({ onClose, t }) => {
  const { currentLanguage } = useLocalisation();
  const { legalInformation } = useLegalInformationService(currentLanguage);
  return (
    <ModalPortal isOpen={true} onClose={onClose}>
      <Dialog
        title={t('BUTTON_TERMS')}
        size={200}
        actions={[
          <Button key={0} theme="brand" ghost label={t('BUTTON_TERMS_CLOSE')} onClick={onClose} />,
        ]}
      >
        <Content
          className="conditions-of-use-modal__content"
          dangerouslySetInnerHTML={{
            __html: `<div>
                ${legalInformation?.termsAndConditions || ''}
              </div>`,
          }}
        />
      </Dialog>
    </ModalPortal>
  );
};

const Content = styled.div`
  font-size: 12px;
  color: #979797;
  background-color: #f4f5f8;
  border: 1px solid #e1e2e6;
  padding: 16px 24px;

  h1 {
    font-size: 1.2rem;
  }

  h2 {
    color: ${({ theme }) => theme.colors.brand100};
    &:nth-child(1) {
      color: #979797;
    }
  }

  div {
    section {
      h2 {
        color: ${({ theme }) => theme.colors.brand100};
        &:nth-child(1) {
          color: ${({ theme }) => theme.colors.brand100};
        }
      }
    }
  }

  & a:link,
  & a:visited {
    color: ${({ theme }) => theme.colors.brand100};
  }
`;
